import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import EnrollmentCharacteristicsPage from './enrollment-characteristics'

const enrollmentCharacteristicsRoutes: Route[] = [
  {
    path: Paths.CHARACTERISTICS_LIST_PAGE,
    element: <EnrollmentCharacteristicsPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default enrollmentCharacteristicsRoutes
